module.exports = __webpack_public_path__ + "media/img/about-us/banner-img-8af4d1775a655f737837dcb8824230e1.jpg";